import { connect } from 'react-redux';
import { getCurrentListRegions } from 'app/state/selectors/currentList';
import RegionDisplay from './view';

const mapStateToProps = state => ({
    regions: getCurrentListRegions(state),
});

export default connect(mapStateToProps)(RegionDisplay);
